"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeInParallel = void 0;
const executeInParallel = (arr, fn, threads) => __awaiter(void 0, void 0, void 0, function* () {
    const items = [...arr]; //
    while (items.length) {
        yield Promise.all(items.splice(0, threads).map((x) => __awaiter(void 0, void 0, void 0, function* () { return yield fn(x); })));
    }
});
exports.executeInParallel = executeInParallel;
